/* Autogenerated file. Do not edit manually. */

import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { BigNumberish, Overrides, Signer } from 'ethers';
import { Contract, ContractFactory, utils } from 'ethers';

import type {
  MogulLaunchpad,
  MogulLaunchpadInterface,
} from '../MogulLaunchpad';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stars',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_vrfCoordinator',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_link',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_owner',
        type: 'address',
      },
      {
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'ticker',
        type: 'string',
      },
      {
        internalType: 'bool',
        name: '_ethAllowed',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: '_starsAllowed',
        type: 'bool',
      },
      {
        internalType: 'uint256[]',
        name: 'ethPrices',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256[]',
        name: 'starsPrices',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'ApprovalCallerNotOwnerNorApproved',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ApprovalQueryForNonexistentToken',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ApprovalToCurrentOwner',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ApproveToCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'BalanceQueryForZeroAddress',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MintToZeroAddress',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MintZeroQuantity',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OwnerIndexOutOfBounds',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OwnerQueryForNonexistentToken',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TokenIndexOutOfBounds',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TransferCallerNotOwnerNorApproved',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TransferFromIncorrectOwner',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TransferToNonERC721ReceiverImplementer',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TransferToZeroAddress',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'approved',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [],
    name: 'MAX_MINT_PER_TX',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_NFT_PURCHASE_PRESALE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_SUPPLY',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NFT_1_PRICE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NFT_1_PRICE_STARS',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NFT_3_PRICE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NFT_3_PRICE_STARS',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NFT_5_PRICE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NFT_5_PRICE_STARS',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'allowListMerkleRoot',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'allowListNumClaimed',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_reserveAmount',
        type: 'uint256',
      },
    ],
    name: 'claimReserve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ethAllowed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'flipPresaleState',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'flipSaleState',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'getApproved',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'hiddenMetadataUri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: '_proof',
        type: 'bytes32[]',
      },
      {
        internalType: 'address',
        name: '_address',
        type: 'address',
      },
    ],
    name: 'isAllowListed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isMetadataLocked',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_numberOfTokens',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_isStarsPurchase',
        type: 'bool',
      },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: '_proof',
        type: 'bytes32[]',
      },
      {
        internalType: 'uint256',
        name: '_numberOfTokens',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_isStarsPurchase',
        type: 'bool',
      },
    ],
    name: 'mintPresale',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'ownerOf',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'presaleIsActive',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'provenance',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'requestId',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: 'randomness',
        type: 'uint256',
      },
    ],
    name: 'rawFulfillRandomness',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_keyHash',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: '_fee',
        type: 'uint256',
      },
    ],
    name: 'requestStartingIndex',
    outputs: [
      {
        internalType: 'bytes32',
        name: 'requestId',
        type: 'bytes32',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'reserve',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'revealed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'saleIsActive',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_allowListMerkleRoot',
        type: 'bytes32',
      },
    ],
    name: 'setAllowListMerkleRoot',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '_hiddenMetadataUri',
        type: 'string',
      },
    ],
    name: 'setHiddenMetadataUri',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '_provenance',
        type: 'string',
      },
    ],
    name: 'setProvenance',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: '_state',
        type: 'bool',
      },
    ],
    name: 'setRevealed',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '_uriPrefix',
        type: 'string',
      },
    ],
    name: 'setUriPrefix',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '_uriSuffix',
        type: 'string',
      },
    ],
    name: 'setUriSuffix',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'starsAllowed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'startingIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'startingIndexRequestId',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'tokenByIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'tokenOfOwnerByIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256',
      },
    ],
    name: 'tokenURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'uriPrefix',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'uriSuffix',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address',
      },
    ],
    name: 'walletOfOwner',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

export class MogulLaunchpadFactory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _stars: string,
    _vrfCoordinator: string,
    _link: string,
    _owner: string,
    name: string,
    ticker: string,
    _ethAllowed: boolean,
    _starsAllowed: boolean,
    ethPrices: BigNumberish[],
    starsPrices: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<MogulLaunchpad> {
    return super.deploy(
      _stars,
      _vrfCoordinator,
      _link,
      _owner,
      name,
      ticker,
      _ethAllowed,
      _starsAllowed,
      ethPrices,
      starsPrices,
      overrides || {},
    ) as Promise<MogulLaunchpad>;
  }
  getDeployTransaction(
    _stars: string,
    _vrfCoordinator: string,
    _link: string,
    _owner: string,
    name: string,
    ticker: string,
    _ethAllowed: boolean,
    _starsAllowed: boolean,
    ethPrices: BigNumberish[],
    starsPrices: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(
      _stars,
      _vrfCoordinator,
      _link,
      _owner,
      name,
      ticker,
      _ethAllowed,
      _starsAllowed,
      ethPrices,
      starsPrices,
      overrides || {},
    );
  }
  attach(address: string): MogulLaunchpad {
    return super.attach(address) as MogulLaunchpad;
  }
  connect(signer: Signer): MogulLaunchpadFactory {
    return super.connect(signer) as MogulLaunchpadFactory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MogulLaunchpadInterface {
    return new utils.Interface(_abi) as MogulLaunchpadInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider,
  ): MogulLaunchpad {
    return new Contract(address, _abi, signerOrProvider) as MogulLaunchpad;
  }
}
